// NOMBASE — Frontend feature flags.
//
// Plain constants. Not env-driven on purpose: these flags gate UI
// surfaces that are intentionally hidden during the simplification
// phase, and we want re-enabling to be a code review + redeploy, not
// a silent env-var flip in prod.
//
// To re-enable a surface: flip the constant to `true` and search for
// usages with `git grep CART_ENABLED` (etc.) to confirm every gated
// caller comes back on.

// Demand decision system (Phase 6 rollout). ENABLED everywhere as of
// 2026-07-23 — the deliberate one-line flip the policy above calls for.
// This only un-hides UI: the backend has always shipped these routes
// unconditionally (`server.py` includes `routes/demand.py`), so production
// was already serving the APIs while the surfaces were dark. It restores:
//   • the Demand nav item (desktop + mobile) and the `/demand/*` route
//   • the channel / accounting / ERP connectors on Settings → Integrations
//     (Shopify, Amazon, QuickBooks, NetSuite, Xero, 3PL/WMS)
export const DEMAND_ENABLED = true;

// Autopilot — production-feasibility / stockout recommendation layer.
// ENABLED everywhere as of 2026-07-23 — the same deliberate flip as Demand
// above. Its engine is covered by the blocking financial core gate
// (test_autopilot.py, test_autopilot_engine.py, test_phase5_automation.py),
// and `server.py` already includes routes/autopilot.py unconditionally.
export const AUTOPILOT_ENABLED = true;


